// extracted by mini-css-extract-plugin
export default {"ContentWrapper":"MainPageWrapper_ContentWrapper__YrrVY","Container":"MainPageWrapper_Container__K67B3"};